// ============================================
// CHATBOT WIDGET POUR SHOPIFY
// ============================================

// Attendre que le DOM soit chargé et que la configuration soit disponible
(function() {
    'use strict';

    // Configuration du chatbot
    const CHATBOT_CONFIG = {
        webhookUrl: 'https://n8n.srv1261952.hstgr.cloud/webhook/2df9ea18-02cc-402d-868b-7db7271a36cb/chat', // URL du webhook n8n
        enabled: true, // Mettre à false pour désactiver temporairement
        simulateMode: false, // Mode simulation désactivé - utilise le webhook n8n
        requestFormat: 'n8n-chat', // Format de requête pour n8n Chat Trigger: 'n8n-chat', 'standard', 'simple'
        // avatarUrl sera défini par window.CHATBOT_CONFIG.avatarUrl depuis le snippet Liquid
        avatarUrl: (window.CHATBOT_CONFIG && window.CHATBOT_CONFIG.avatarUrl) || 'Photos/milou-avatar.webp.png'
    };

    // Gestion de la session pour n8n Chat Trigger
    let chatSessionId = null;

    // Éléments du DOM
    let chatbotToggle = null;
    let chatbotWindow = null;
    let chatbotClose = null;
    let chatbotInput = null;
    let chatbotSend = null;
    let chatbotMessages = null;
    let chatbotBadge = null;

    // État du chatbot
    let unreadCount = 0;
    let isOpen = false;
    let notificationShown = false;

    // Initialiser le chatbot une fois le DOM chargé
    function initChatbot() {
        // Vérifier si le chatbot est désactivé
        if (!CHATBOT_CONFIG.enabled) {
            // Cacher complètement le container si désactivé
            const container = document.getElementById('chatbot-container');
            if (container) {
                container.style.display = 'none';
                container.style.visibility = 'hidden';
            }
            console.log('Chatbot: Désactivé via CHATBOT_CONFIG.enabled = false');
            return;
        }

        // Ajouter classe pour indiquer que le chatbot est activé
        document.body.classList.add('chatbot-enabled');

        // Obtenir les éléments du DOM
        chatbotToggle = document.getElementById('chatbot-toggle');
        chatbotWindow = document.getElementById('chatbot-window');
        chatbotClose = document.getElementById('chatbot-close');
        chatbotInput = document.getElementById('chatbot-input');
        chatbotSend = document.getElementById('chatbot-send');
        chatbotMessages = document.getElementById('chatbot-messages');
        chatbotBadge = document.getElementById('chatbot-badge');

        // Vérifier que tous les éléments nécessaires existent
        if (!chatbotToggle || !chatbotWindow) {
            console.warn('Chatbot: Éléments DOM non trouvés. Assurez-vous que le snippet chatbot.liquid est inclus dans theme.liquid');
            return;
        }

        // Configurer les event listeners
        setupEventListeners();
    }

    // Configurer les event listeners
    function setupEventListeners() {
        // Ouvrir/fermer le chat
        if (chatbotToggle && chatbotWindow) {
            chatbotToggle.addEventListener('click', () => {
                toggleChatbot();
            });

            if (chatbotClose) {
                chatbotClose.addEventListener('click', () => {
                    closeChatbot();
                });
            }
        }

        // Envoyer un message
        if (chatbotSend) {
            chatbotSend.addEventListener('click', sendMessage);
        }

        if (chatbotInput) {
            chatbotInput.addEventListener('keypress', (e) => {
                if (e.key === 'Enter' && !e.shiftKey) {
                    e.preventDefault();
                    sendMessage();
                }
            });
            
            // Gérer l'ouverture/fermeture du clavier sur mobile
            chatbotInput.addEventListener('focus', handleKeyboardOpen);
            chatbotInput.addEventListener('blur', handleKeyboardClose);
        }
        
        // Utiliser visualViewport API pour détecter les changements de taille
        if (window.visualViewport) {
            window.visualViewport.addEventListener('resize', handleViewportResize);
            window.visualViewport.addEventListener('scroll', handleViewportScroll);
        }
        
        // Fallback: écouter les changements de window.innerHeight (change quand le clavier s'ouvre sur mobile)
        let lastInnerHeight = window.innerHeight;
        window.addEventListener('resize', () => {
            const isMobile = window.innerWidth <= 480 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
            if (isMobile && chatbotWindow && isOpen) {
                const currentInnerHeight = window.innerHeight;
                // Si la hauteur a diminué significativement (plus de 150px), le clavier est probablement ouvert
                if (currentInnerHeight < lastInnerHeight - 150) {
                    if (chatbotInput && document.activeElement === chatbotInput) {
                        chatbotWindow.classList.add('keyboard-open');
                        adjustWindowForKeyboard();
                    }
                } else if (currentInnerHeight > lastInnerHeight + 100) {
                    // Le clavier se ferme probablement
                    if (chatbotInput && document.activeElement !== chatbotInput) {
                        chatbotWindow.classList.remove('keyboard-open');
                        resetWindowPosition();
                    }
                }
                lastInnerHeight = currentInnerHeight;
            }
        });

        // Arrêter l'animation si l'utilisateur clique sur le bouton
        if (chatbotToggle) {
            chatbotToggle.addEventListener('click', () => {
                stopNotificationAnimation();
            });
        }
    }

    function toggleChatbot() {
        isOpen = !isOpen;
        if (isOpen) {
            openChatbot();
        } else {
            closeChatbot();
        }
    }

    function openChatbot() {
        if (chatbotWindow) {
            chatbotWindow.classList.add('open');
            isOpen = true;
            unreadCount = 0;
            updateBadge();
            // Arrêter l'animation de notification quand le chat s'ouvre
            stopNotificationAnimation();
            // Focus sur l'input après un court délai pour permettre l'animation
            setTimeout(() => {
                if (chatbotInput) {
                    chatbotInput.focus();
                }
            }, 100);
        }
    }

    function closeChatbot() {
        if (chatbotWindow) {
            chatbotWindow.classList.remove('open');
            isOpen = false;
        }
    }

    // Envoyer un message
    async function sendMessage() {
        const message = chatbotInput?.value.trim();
        if (!message || !chatbotSend) return;

        // Désactiver le bouton d'envoi
        chatbotSend.disabled = true;

        // Afficher le message de l'utilisateur
        addMessage(message, 'user');
        if (chatbotInput) chatbotInput.value = '';

        // Afficher un indicateur de chargement
        const loadingElement = addLoadingMessage();

        try {
            let botResponse;

            if (CHATBOT_CONFIG.webhookUrl && !CHATBOT_CONFIG.simulateMode) {
                // Envoyer au webhook n8n Chat Trigger
                // Les n8n Chat Triggers en mode "Embedded Chat" attendent un format spécifique
                let requestBody;
                let headers = {
                    'Content-Type': 'application/json'
                };
                
                if (CHATBOT_CONFIG.requestFormat === 'n8n-chat') {
                    // Format pour n8n Chat Trigger en mode Embedded Chat
                    // Doit inclure action, sessionId et chatInput
                    if (!chatSessionId) {
                        chatSessionId = 'session-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
                    }
                    const requestData = {
                        action: 'sendMessage',
                        sessionId: chatSessionId,
                        chatInput: message
                    };
                    requestBody = JSON.stringify(requestData);
                } else if (CHATBOT_CONFIG.requestFormat === 'simple') {
                    // Format simple - juste le message
                    requestBody = JSON.stringify({ message: message });
                } else {
                    // Format standard avec message et timestamp
                    requestBody = JSON.stringify({
                        message: message,
                        timestamp: new Date().toISOString()
                    });
                }
                
                console.log('Envoi au webhook n8n Chat:', CHATBOT_CONFIG.webhookUrl, 'Format:', CHATBOT_CONFIG.requestFormat, requestBody);
                
                const response = await fetch(CHATBOT_CONFIG.webhookUrl, {
                    method: 'POST',
                    headers: headers,
                    body: requestBody
                });

                if (!response.ok) {
                    let errorDetails = '';
                    try {
                        const errorData = await response.json();
                        errorDetails = errorData.message || errorData.error || JSON.stringify(errorData);
                        console.error('Erreur HTTP détaillée:', response.status, errorData);
                    } catch (e) {
                        const errorText = await response.text();
                        errorDetails = errorText || 'Erreur inconnue';
                        console.error('Erreur HTTP (texte):', response.status, errorText);
                    }
                    
                    // Créer un message d'erreur plus informatif
                    const errorMessage = response.status === 500 
                        ? `Erreur du serveur n8n: ${errorDetails}. Vérifiez la configuration du workflow.`
                        : `Erreur HTTP ${response.status}: ${errorDetails}`;
                    
                    throw new Error(errorMessage);
                }

                // Vérifier le type de contenu de la réponse
                const contentType = response.headers.get('content-type');
                let data;
                
                if (contentType && contentType.includes('application/json')) {
                    data = await response.json();
                } else {
                    // Si la réponse n'est pas JSON, essayer de la lire comme texte
                    const textResponse = await response.text();
                    console.log('Réponse texte du webhook:', textResponse);
                    // Essayer de parser comme JSON si possible
                    try {
                        data = JSON.parse(textResponse);
                    } catch (e) {
                        // Si ce n'est pas du JSON, utiliser le texte directement
                        data = textResponse;
                    }
                }
                
                console.log('Données reçues du webhook:', data);
                
                // Extraire le sessionId de la réponse si présent (pour maintenir la session)
                if (data && typeof data === 'object') {
                    const jsonData = data.json || data;
                    if (jsonData.sessionId && !chatSessionId) {
                        chatSessionId = jsonData.sessionId;
                        console.log('SessionId reçu du webhook:', chatSessionId);
                    }
                }
                
                // Adapter selon le format de réponse de n8n Chat Trigger
                // Les n8n Chat Triggers retournent souvent les données dans un format spécifique
                if (typeof data === 'string') {
                    botResponse = data;
                } else if (Array.isArray(data) && data.length > 0) {
                    // Si n8n retourne un tableau, prendre le premier élément
                    const firstItem = data[0];
                    // Pour les Chat Triggers, la réponse peut être dans json.output ou directement
                    const jsonData = firstItem.json || firstItem;
                    botResponse = jsonData.output || jsonData.response || jsonData.message || 
                                 jsonData.text || jsonData.reply || 
                                 (typeof firstItem === 'string' ? firstItem : JSON.stringify(firstItem));
                } else if (data && typeof data === 'object') {
                    // Gérer firstEntryJson si présent (format spécifique n8n)
                    if (data.firstEntryJson) {
                        const entryData = typeof data.firstEntryJson === 'string' 
                            ? JSON.parse(data.firstEntryJson) 
                            : data.firstEntryJson;
                        const jsonData = entryData.json || entryData;
                        botResponse = jsonData.output || jsonData.response || jsonData.message || 
                                     jsonData.text || jsonData.reply || JSON.stringify(entryData);
                    } else {
                        // Chercher dans différentes propriétés possibles pour Chat Triggers
                        // Les Chat Triggers retournent souvent dans json.output
                        const jsonData = data.json || data;
                        botResponse = jsonData.output || jsonData.response || jsonData.message || 
                                     jsonData.text || jsonData.reply || 
                                     data.output || data.response || data.message || data.text || data.reply ||
                                     data.data?.output || data.data?.response || data.data?.message || 
                                     data.body?.output || data.body?.response || data.body?.message ||
                                     'Désolé, je n\'ai pas pu traiter votre demande.';
                    }
                } else {
                    botResponse = 'Désolé, je n\'ai pas pu traiter votre demande.';
                }
            } else {
                // Mode simulation (réponses automatiques)
                botResponse = getSimulatedResponse(message);
                // Simuler un délai réseau
                await new Promise(resolve => setTimeout(resolve, 800));
            }

            // Supprimer le message de chargement
            removeMessage(loadingElement);
            
            // Afficher la réponse du bot
            addMessage(botResponse, 'bot');
            
            if (!isOpen) {
                unreadCount++;
                updateBadge();
            }
        } catch (error) {
            // Supprimer le message de chargement
            removeMessage(loadingElement);
            
            // Afficher un message d'erreur avec plus de détails en console
            console.error('Erreur chatbot complète:', {
                error: error,
                message: error.message,
                stack: error.stack,
                webhookUrl: CHATBOT_CONFIG.webhookUrl
            });
            
            // Afficher un message d'erreur plus convivial
            let errorMessage;
            if (error.message.includes('500') || error.message.includes('Erreur du serveur n8n')) {
                errorMessage = 'Désolé, le service de chat est temporairement indisponible. L\'erreur vient du workflow n8n. Veuillez vérifier la configuration du workflow ou réessayer plus tard.';
            } else if (error.message.includes('CORS') || error.message.includes('Failed to fetch')) {
                errorMessage = 'Impossible de se connecter au service de chat. Vérifiez votre connexion internet.';
            } else {
                errorMessage = CHATBOT_CONFIG.webhookUrl 
                    ? `Désolé, une erreur est survenue: ${error.message}. Veuillez réessayer plus tard.` 
                    : 'Le chatbot est en cours de configuration. Veuillez patienter.';
            }
            addMessage(errorMessage, 'bot');
        } finally {
            // Réactiver le bouton d'envoi
            if (chatbotSend) chatbotSend.disabled = false;
        }
    }

    // Réponses simulées (pour tester avant la configuration n8n)
    function getSimulatedResponse(message) {
        const lowerMessage = message.toLowerCase();
        
        if (lowerMessage.includes('bonjour') || lowerMessage.includes('salut') || lowerMessage.includes('hello')) {
            return 'Bonjour ! Comment puis-je vous aider aujourd\'hui ?';
        }
        if (lowerMessage.includes('prix') || lowerMessage.includes('coût') || lowerMessage.includes('tarif')) {
            return 'Vous pouvez consulter nos prix directement sur la page des produits. N\'hésitez pas à me dire si vous avez des questions spécifiques !';
        }
        if (lowerMessage.includes('livraison') || lowerMessage.includes('expédition')) {
            return 'Nous offrons la livraison gratuite pour les commandes de 60$ et plus ! 🎉';
        }
        if (lowerMessage.includes('commande') || lowerMessage.includes('acheter') || lowerMessage.includes('panier')) {
            return 'Vous pouvez ajouter des produits à votre panier directement depuis la page boutique. Besoin d\'aide pour autre chose ?';
        }
        if (lowerMessage.includes('merci') || lowerMessage.includes('remercie')) {
            return 'De rien ! N\'hésitez pas si vous avez d\'autres questions. 😊';
        }
        
        return 'Merci pour votre message ! Le chatbot est en cours de configuration. Pour le moment, je peux vous informer que nous offrons la livraison gratuite à partir de 60$ d\'achat.';
    }

    // Fonction pour convertir les URLs et emails en liens cliquables
    function linkify(text) {
        // D'abord, traiter les emails AVANT les URLs pour éviter les conflits
        // Pattern pour les adresses email - doit contenir @ et un domaine valide
        const emailPattern = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/gi;
        
        // Expression régulière pour détecter les URLs
        // Pattern pour http:// ou https:// - s'arrête aux espaces, saut de ligne, ou caractères non-URL
        const httpPattern = /(https?:\/\/[^\s<>"{}|\\^`\[\]]+)/gi;
        // Pattern pour www. - s'arrête aux espaces, saut de ligne, ou caractères non-URL
        const wwwPattern = /(www\.[^\s<>"{}|\\^`\[\]]+)/gi;
        
        let result = text;
        
        // Remplacer les adresses email EN PREMIER (pour éviter les conflits avec les URLs)
        result = result.replace(emailPattern, (match) => {
            // Nettoyer l'email en enlevant la ponctuation finale qui ne fait pas partie de l'email
            let cleanEmail = match.replace(/[.,;:!?)\]}]+$/, '');
            return `<a href="mailto:${cleanEmail}" style="color: #2c3e50; text-decoration: underline; word-break: break-all;">${cleanEmail}</a>`;
        });
        
        // Remplacer les URLs http/https (après les emails)
        result = result.replace(httpPattern, (match) => {
            // Vérifier que ce n'est pas déjà dans un lien
            if (match.includes('</a>') || match.includes('<a')) {
                return match;
            }
            // Nettoyer l'URL en enlevant la ponctuation finale qui ne fait pas partie de l'URL
            // Garder les caractères valides dans les URLs comme /, ?, &, =, #, etc.
            let cleanUrl = match.replace(/[.,;:!?)\]}]+$/, '');
            return `<a href="${cleanUrl}" target="_blank" rel="noopener noreferrer" style="color: #2c3e50; text-decoration: underline; word-break: break-all;">${cleanUrl}</a>`;
        });
        
        // Remplacer les URLs www. (après http pour éviter les doublons)
        result = result.replace(wwwPattern, (match) => {
            // Vérifier que ce n'est pas déjà dans un lien
            if (match.includes('</a>') || match.includes('<a')) {
                return match;
            }
            // Nettoyer l'URL en enlevant la ponctuation finale
            let cleanUrl = match.replace(/[.,;:!?)\]}]+$/, '');
            let href = 'https://' + cleanUrl;
            return `<a href="${href}" target="_blank" rel="noopener noreferrer" style="color: #2c3e50; text-decoration: underline; word-break: break-all;">${cleanUrl}</a>`;
        });
        
        return result;
    }

    // Ajouter un message
    function addMessage(text, type) {
        if (!chatbotMessages) return null;
        
        const messageDiv = document.createElement('div');
        messageDiv.className = `message ${type}`;
        
        // Ajouter l'avatar de Milou pour les messages du bot
        if (type === 'bot') {
            const avatarImg = document.createElement('img');
            avatarImg.src = CHATBOT_CONFIG.avatarUrl;
            avatarImg.alt = 'Milou';
            avatarImg.className = 'message-avatar';
            avatarImg.onerror = function() { this.style.display = 'none'; };
            messageDiv.appendChild(avatarImg);
        }
        
        const wrapperDiv = document.createElement('div');
        wrapperDiv.className = 'message-wrapper';
        
        const contentDiv = document.createElement('div');
        contentDiv.className = 'message-content';
        
        const textP = document.createElement('p');
        // Convertir les URLs et emails en liens cliquables AVANT de convertir les retours à la ligne
        let processedText = linkify(text);
        // Convertir les retours à la ligne en <br> après avoir créé les liens
        processedText = processedText.replace(/\n/g, '<br>');
        textP.innerHTML = processedText;
        contentDiv.appendChild(textP);
        
        const timeDiv = document.createElement('div');
        timeDiv.className = 'message-time';
        timeDiv.textContent = getCurrentTime();
        
        wrapperDiv.appendChild(contentDiv);
        wrapperDiv.appendChild(timeDiv);
        
        messageDiv.appendChild(wrapperDiv);
        chatbotMessages.appendChild(messageDiv);
        scrollToBottom();
        
        return messageDiv;
    }

    // Ajouter un message de chargement
    function addLoadingMessage() {
        if (!chatbotMessages) return null;
        
        const messageDiv = document.createElement('div');
        messageDiv.className = 'message bot loading';
        
        // Ajouter l'avatar de Milou pour le message de chargement
        const avatarImg = document.createElement('img');
        avatarImg.src = CHATBOT_CONFIG.avatarUrl;
        avatarImg.alt = 'Milou';
        avatarImg.className = 'message-avatar';
        avatarImg.onerror = function() { this.style.display = 'none'; };
        messageDiv.appendChild(avatarImg);
        
        const wrapperDiv = document.createElement('div');
        wrapperDiv.className = 'message-wrapper';
        
        const contentDiv = document.createElement('div');
        contentDiv.className = 'message-content';
        
        for (let i = 0; i < 3; i++) {
            const span = document.createElement('span');
            contentDiv.appendChild(span);
        }
        
        wrapperDiv.appendChild(contentDiv);
        messageDiv.appendChild(wrapperDiv);
        chatbotMessages.appendChild(messageDiv);
        scrollToBottom();
        
        return messageDiv;
    }

    // Supprimer un message
    function removeMessage(messageElement) {
        if (messageElement && messageElement.parentNode) {
            messageElement.parentNode.removeChild(messageElement);
        }
    }

    // Obtenir l'heure actuelle formatée
    function getCurrentTime() {
        const now = new Date();
        return now.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
    }

    // Faire défiler vers le bas
    function scrollToBottom() {
        if (chatbotMessages) {
            chatbotMessages.scrollTop = chatbotMessages.scrollHeight;
        }
    }

    // Mettre à jour le badge
    function updateBadge() {
        if (chatbotBadge) {
            if (unreadCount > 0) {
                chatbotBadge.textContent = unreadCount > 9 ? '9+' : unreadCount.toString();
                chatbotBadge.classList.add('active');
            } else {
                chatbotBadge.classList.remove('active');
            }
        }
    }

    // Animation de notification pour inciter l'utilisateur à cliquer
    function startNotificationAnimation() {
        if (notificationShown || isOpen) return;
        
        const notificationPulse = document.getElementById('chatbot-notification-pulse');
        const toggle = chatbotToggle;
        
        if (notificationPulse && toggle) {
            notificationPulse.classList.add('active');
            toggle.classList.add('notification-pulse');
            notificationShown = true;
        }
    }

    function stopNotificationAnimation() {
        const notificationPulse = document.getElementById('chatbot-notification-pulse');
        const toggle = chatbotToggle;
        
        if (notificationPulse) {
            notificationPulse.classList.remove('active');
        }
        if (toggle) {
            toggle.classList.remove('notification-pulse');
        }
        notificationShown = false;
    }

    // Gérer l'ouverture du clavier sur mobile
    function handleKeyboardOpen() {
        if (!chatbotWindow) return;
        
        // Détecter si on est sur mobile
        const isMobile = window.innerWidth <= 480 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        
        if (isMobile) {
            chatbotWindow.classList.add('keyboard-open');
            
            // Ajuster immédiatement
            adjustWindowForKeyboard();
            
            // Ajuster plusieurs fois pour s'assurer que le clavier est complètement ouvert
            // Les délais permettent au navigateur de terminer l'animation du clavier
            setTimeout(() => {
                adjustWindowForKeyboard();
            }, 100);
            
            setTimeout(() => {
                adjustWindowForKeyboard();
            }, 300);
            
            setTimeout(() => {
                adjustWindowForKeyboard();
            }, 500);
        }
    }

    // Gérer la fermeture du clavier sur mobile
    function handleKeyboardClose() {
        if (!chatbotWindow) return;
        
        const isMobile = window.innerWidth <= 480 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        
        if (isMobile) {
            // Attendre un peu avant de retirer la classe pour éviter les clignotements
            setTimeout(() => {
                if (chatbotInput && document.activeElement !== chatbotInput) {
                    chatbotWindow.classList.remove('keyboard-open');
                    resetWindowPosition();
                }
            }, 100);
        }
    }

    // Ajuster la fenêtre pour le clavier avec visualViewport
    function adjustWindowForKeyboard() {
        if (!chatbotWindow) return;
        
        // Utiliser visualViewport si disponible (meilleure précision)
        if (window.visualViewport) {
            const viewport = window.visualViewport;
            const windowHeight = viewport.height;
            const windowTop = viewport.offsetTop;
            const windowLeft = viewport.offsetLeft;
            const windowWidth = viewport.width;
            
            // Calculer la hauteur disponible (utiliser presque toute la hauteur visible)
            const availableHeight = Math.max(windowHeight - 10, 300); // Minimum 300px, 5px de marge en haut et en bas
            
            // Calculer la largeur disponible et centrer
            const availableWidth = Math.min(windowWidth - 20, 420); // Max 420px comme défini dans le CSS
            const leftPosition = windowLeft + (windowWidth - availableWidth) / 2;
            
            // Ajuster la hauteur et la position avec !important via style inline
            chatbotWindow.style.setProperty('height', `${availableHeight}px`, 'important');
            chatbotWindow.style.setProperty('max-height', `${availableHeight}px`, 'important');
            chatbotWindow.style.setProperty('min-height', '0', 'important');
            chatbotWindow.style.setProperty('width', `${availableWidth}px`, 'important');
            chatbotWindow.style.setProperty('top', `${windowTop + 5}px`, 'important');
            chatbotWindow.style.setProperty('left', `${leftPosition}px`, 'important');
            chatbotWindow.style.setProperty('right', 'auto', 'important');
            chatbotWindow.style.setProperty('bottom', 'auto', 'important');
            chatbotWindow.style.setProperty('margin', '0', 'important');
        } else {
            // Fallback: utiliser window.innerHeight (moins précis mais fonctionne)
            // Sur mobile, innerHeight change quand le clavier s'ouvre
            const windowHeight = window.innerHeight;
            const windowWidth = window.innerWidth;
            const availableHeight = Math.max(windowHeight - 10, 300); // Minimum 300px
            const availableWidth = Math.min(windowWidth - 20, 420);
            const leftPosition = (windowWidth - availableWidth) / 2;
            
            chatbotWindow.style.setProperty('height', `${availableHeight}px`, 'important');
            chatbotWindow.style.setProperty('max-height', `${availableHeight}px`, 'important');
            chatbotWindow.style.setProperty('min-height', '0', 'important');
            chatbotWindow.style.setProperty('width', `${availableWidth}px`, 'important');
            chatbotWindow.style.setProperty('top', '5px', 'important');
            chatbotWindow.style.setProperty('left', `${leftPosition}px`, 'important');
            chatbotWindow.style.setProperty('right', 'auto', 'important');
            chatbotWindow.style.setProperty('bottom', 'auto', 'important');
            chatbotWindow.style.setProperty('margin', '0', 'important');
        }
        
        // S'assurer que la fenêtre est bien positionnée
        chatbotWindow.style.setProperty('position', 'fixed', 'important');
        
        // Faire défiler vers le bas après un court délai
        setTimeout(() => {
            scrollToBottom();
        }, 200);
    }

    // Réinitialiser la position de la fenêtre
    function resetWindowPosition() {
        if (!chatbotWindow) return;
        
        // Retirer tous les styles inline pour revenir aux styles CSS
        chatbotWindow.style.removeProperty('height');
        chatbotWindow.style.removeProperty('max-height');
        chatbotWindow.style.removeProperty('min-height');
        chatbotWindow.style.removeProperty('width');
        chatbotWindow.style.removeProperty('top');
        chatbotWindow.style.removeProperty('left');
        chatbotWindow.style.removeProperty('right');
        chatbotWindow.style.removeProperty('bottom');
        chatbotWindow.style.removeProperty('position');
        chatbotWindow.style.removeProperty('margin');
    }

    // Gérer le redimensionnement du viewport (quand le clavier s'ouvre/ferme)
    function handleViewportResize() {
        if (!chatbotWindow || !isOpen) return;
        
        const isMobile = window.innerWidth <= 480 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        
        if (isMobile) {
            // Vérifier si l'input a le focus (clavier ouvert)
            if (chatbotInput && document.activeElement === chatbotInput) {
                adjustWindowForKeyboard();
            } else {
                // Clavier fermé, réinitialiser
                chatbotWindow.classList.remove('keyboard-open');
                resetWindowPosition();
            }
        }
    }

    // Gérer le scroll du viewport
    function handleViewportScroll() {
        if (!chatbotWindow || !isOpen) return;
        
        const isMobile = window.innerWidth <= 480 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        
        if (isMobile && chatbotInput && document.activeElement === chatbotInput) {
            // Réajuster si nécessaire lors du scroll
            adjustWindowForKeyboard();
        }
    }

    // Démarrer l'animation après 5 secondes sur le site
    // Ne s'affiche que si le chat n'est pas déjà ouvert
    setTimeout(() => {
        if (!isOpen) {
            startNotificationAnimation();
        }
    }, 5000);

    // Mettre à jour l'avatar URL depuis window.CHATBOT_CONFIG si disponible
    if (window.CHATBOT_CONFIG && window.CHATBOT_CONFIG.avatarUrl) {
        CHATBOT_CONFIG.avatarUrl = window.CHATBOT_CONFIG.avatarUrl;
    }

    // Initialiser le chatbot une fois le DOM chargé
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            // Vérifier à nouveau l'avatar URL au cas où il serait défini après le chargement initial
            if (window.CHATBOT_CONFIG && window.CHATBOT_CONFIG.avatarUrl) {
                CHATBOT_CONFIG.avatarUrl = window.CHATBOT_CONFIG.avatarUrl;
            }
            initChatbot();
        });
    } else {
        // Le DOM est déjà chargé
        initChatbot();
    }

})();
